/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import type { OrdersV2 } from '@/api/ordersV2/types';
import ResultPage, { ResultPageStatusEnum } from '@/components/result-page';
import FinanceBusiness from '@/mixins/finance-business';
import { RouterV2Enum } from '@/router/router-names';
import RouterHelper from '@/shared/utils/routerHelper';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import ChangeChannelList from '@/components/change-channel';
import { jumpToMarketPage } from '@/shared/utils/jumpToRedirectPage';
import { isH5App } from '@/constant';
import { agreementService } from '@/service/confirm-agreements';
import { namespace } from 'vuex-class';
import ApplyContentDetails from '../apply-content';
import '@/views_v2/home/store';

const style = require('./index.module.scss');

const HomeStore = namespace('home');

@Component({ name: 'ApplyFailDetails' })
export default class ApplyFailDetails extends Mixins(FinanceBusiness) {
  @Prop()
  private commodityDetail!: OrdersV2.CommodityDetail;

  @Prop()
  private orderDetail!: OrdersV2.OrderDetail;

  @HomeStore.Action getUserAutarkyState!: () => Promise<boolean>;

  // 授信新的渠道
  private async getNewCredit() {
    if (isH5App) {
      jumpToMarketPage();
    } else {
      await agreementService.confirmFinanceAgreements();
      this.isNeedEducation(
        'finance_withDrawDetails_failed_changeWithdrawlChannel',
        ['产品', `${this.commodityDetail.commodityId}`],
      );
    }
  }

  // 更换新渠道
  /**
   * TODO: 此处跳转有问题，能正确跳转提现页（默认选中第一个可提现渠道），但是携带的productId参数是错的
   * 已于新星哥沟通，暂不搭车上线此问题修改代码。后续有此页面功能改动时再修复
   * 具体改动见分支feature/SKXDZC-apply-details_fix
   */
  private onReApply(productId: string) {
    this.$ubtPageButton(
      'finance_withDrawDetails_failed_applyForNewChannel',
      'productId',
      productId,
    );
    const applyProduct = `${RouterV2Enum.applyProduct}?commodityId=${productId}&source=fundsdrawfail`;
    RouterHelper.navigate(applyProduct);
  }

  private async mounted() {
    await this.getUserAutarkyState();
  }

  private render() {
    return (
      <div class={style.applyFailedDetails}>
        {// 挂载身份证清晰分不够弹窗 dom
          this.getUpdatedIdentityPhotoDialog()
        }
        <ResultPage
          class={style.applyFailedInfo}
          title="提现失败"
          status={ResultPageStatusEnum.FAIL}
          productIcon={this.commodityDetail && this.commodityDetail.icon}
          amount={this.orderDetail ? this.orderDetail.amount : ''}
        >
          <ApplyContentDetails
            orderDetail={this.orderDetail}
            commodityDetail={this.commodityDetail}
          />
        </ResultPage>
        <div>
          <ChangeChannelList
            commodityId={this.commodityDetail ? this.commodityDetail.commodityId : ''}
            onReApply={this.onReApply.bind(this)}
          />
          {/* 自营授信成功用户，隐藏按钮 */}
          {!this.isAutarkySucceed() && (
            <div class={style.applyNewCredit}>
              <div
                class={style.applyNewCreditButton}
                onClick={this.getNewCredit.bind(this)}
              >
                申请新额度
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
